import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { apiFetch, ApiError, Me } from '../api/client';
import PortalLoading from '../shell/PortalLoading';

export default function Landing() {
  const { getToken, signOut } = useAuth();
  const [me, setMe] = useState<Me | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const t = await getToken(); // null for client users — cookie carries credential
        const data = await apiFetch<Me>('/portal/me', t);
        setMe(data);
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) setUnauthorized(true);
        else setError(e instanceof Error ? e.message : String(e));
      }
    })();
  }, [getToken]);

  if (unauthorized) return <Navigate to="/login" replace />;
  if (error) return (
    <div style={{ padding: 32 }}>
      <h2 style={{ color: 'var(--mi-navy)' }}>Could not load your workspace</h2>
      <pre style={{ background: '#fee', padding: 12, borderRadius: 6 }}>{error}</pre>
      <button className="btn-primary" onClick={signOut}>Sign out</button>
    </div>
  );
  if (!me) return <PortalLoading />;

  // Staff (admin / client admin / pending) land in the admin area, which
  // handles the no-role case with its own "no access" screen.
  if (me.user.role === 'staff') return <Navigate to="/admin" replace />;

  // Client users: jump straight into their portal when there's exactly one;
  // otherwise show the picker below.
  if (me.clients.length === 1) return <Navigate to={`/${me.clients[0].slug}`} replace />;

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ color: 'var(--mi-navy)' }}>Your workspaces</h1>
      {me.clients.length === 0 ? (
        <div className="card" style={{ marginTop: 16 }}>
          <p style={{ marginTop: 0 }}>You don’t have access to any workspaces yet.</p>
          <button onClick={signOut} style={{ background: 'transparent', border: '1px solid var(--mi-border)', borderRadius: 6, padding: '6px 12px' }}>Sign out</button>
        </div>
      ) : (
        <ul>
          {me.clients.map((c) => (
            <li key={c.id}><Link to={`/${c.slug}`}>{c.name}</Link></li>
          ))}
        </ul>
      )}
    </div>
  );
}
